import { Store } from "@/zustand/store";
import { StateCreator } from "zustand";

export type DateParamsSlice = {
  dateFrom: Date | null;
  dateTo: Date | null;
  changeDateFrom: (dateFrom: Date) => void;
  changeDateTo: (dateTo: Date) => void;
};

const initialData = {
  dateFrom: null,
  dateTo: null,
};

export const createDateParamsSlice: StateCreator<
  Store,
  [],
  [],
  DateParamsSlice
> = (set) => ({
  ...initialData,
  changeDateFrom: (dateFrom) => set({ dateFrom }),
  changeDateTo: (dateTo) => set({ dateTo }),
});
4;
